import React from 'react';
import moment from 'moment-timezone';
import InfoSection from '../caseInfo/InfoSection';
import Typography from '../../common/Typography';

interface PathologistInfoProps {
  name: string;
  completedAt?: number | null;
}

const PathologistInfo: React.FC<PathologistInfoProps> = ({
  name,
  completedAt,
}) => {
  return (
    <InfoSection title="Pathologist">
      <Typography fontSize="14px">{name}</Typography>
      {completedAt && (
        <Typography fontSize="14px">
          {moment.tz(completedAt, 'UTC').tz(moment.tz.guess()).format('llll z')}
        </Typography>
      )}
    </InfoSection>
  );
};

export default PathologistInfo;
